'use client'

import { useEffect } from 'react'

const OPEN_DISMISSABLE_LAYER_SELECTOR =
  '[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"], [role="menu"][data-state="open"], [role="listbox"][data-state="open"]'

const RELEASE_AFTER_LAYER_CLOSE_MS = 350

export function hasOpenDismissableLayer(): boolean {
  if (typeof document === 'undefined') {
    return false
  }

  return document.querySelector(OPEN_DISMISSABLE_LAYER_SELECTOR) !== null
}

export function releaseStuckBodyPointerEvents(): void {
  if (typeof document === 'undefined') {
    return
  }

  if (document.body.style.pointerEvents !== 'none') {
    return
  }

  if (hasOpenDismissableLayer()) {
    return
  }

  document.body.style.pointerEvents = ''
}

export function useReleaseStuckBodyPointerEvents(): void {
  useEffect(() => {
    let delayedReleaseId: number | undefined

    const scheduleRelease = () => {
      releaseStuckBodyPointerEvents()
      window.clearTimeout(delayedReleaseId)
      delayedReleaseId = window.setTimeout(() => {
        releaseStuckBodyPointerEvents()
      }, RELEASE_AFTER_LAYER_CLOSE_MS)
    }

    scheduleRelease()

    const observer = new MutationObserver(() => {
      scheduleRelease()
    })

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
      childList: true,
      subtree: true,
    })

    return () => {
      observer.disconnect()
      window.clearTimeout(delayedReleaseId)
    }
  }, [])
}
